import { globalStyle, style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { shiftHoverStroke } from '@customerio/pluma-components/css/utils';

/**
 * Pluma-compatible Stripe input styling. Replicates a Pluma text field's input-wrapper appearance so
 * the Stripe Elements iframe visually matches the rest of the form (in both light and dark mode).
 */
export const stripeInput = style(
  {
    backgroundColor: themeVars.color['surface-content'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    borderRadius: themeVars.radius['3'],
    color: themeVars.color['text-primary'],
    height: themeVars.space['450'],
    padding: `0 calc(${themeVars.space['100']} - ${themeVars.border['width-0125']})`,
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    transition: 'border-color 125ms, outline-color 125ms',
    outlineWidth: themeVars.border['width-025'],
    outlineStyle: 'solid',
    outlineColor: 'transparent',
    outlineOffset: themeVars.space['025'],
  },
  'stripe-input',
);

// Stripe's internal wrapper and iframe must fill the flex container.
globalStyle(`${stripeInput} > *`, {
  flex: '1',
});

globalStyle(`${stripeInput}.is-focused`, {
  borderColor: themeVars.color['scope-accent-border'],
  outlineColor: themeVars.color['scope-focus-border'],
});

globalStyle(`${stripeInput}.is-error`, {
  borderColor: themeVars.color['scope-critical-border'],
});

globalStyle(`${stripeInput}:hover:not(.is-focused):not(.is-error)`, {
  borderColor: shiftHoverStroke(themeVars.color['scope-neutral-subtle-border']),
});
